import { Component, EventEmitter, Input, OnChanges, OnInit, Output, ElementRef, ViewChild } from '@angular/core';

import { TestPurposeDto, InstitutionDto, TestSessionForRegistrationDto } from 'src/app/core/dtos/dto';
import { BrandEnum, TestPurposeEnum, TestTypeEnum } from 'src/app/core/dtos/enum';
import { TestPurposeOption } from 'src/app/core/dtos/test-purpose-option';
import { ConfigHelper } from 'src/app/core/services/helpers/config.helper';

@Component({
  selector: 'app-proof-of-identity-test-purpose',
  templateUrl: './proof-of-identity-test-purpose.component.html',
  styleUrls: ['./proof-of-identity-test-purpose.component.scss']
})
export class ProofOfIdentityTestPurposeComponent implements OnInit, OnChanges {
  @Input() testPurposes: TestPurposeDto[];
  @Input() institutions: InstitutionDto[];
  @Input() subscribedInstitutions: Map<TestPurposeEnum, InstitutionDto[]>;
  @Input() testSession: TestSessionForRegistrationDto;
  @Input() storedTestPurposeOption: TestPurposeOption;
  @Input() testTypeId: TestTypeEnum;
  @Input() isWebDelivery: boolean;

  @Output() continue = new EventEmitter<TestPurposeOption>();
  @Output() selectNewTestPurpose = new EventEmitter<TestPurposeOption>();

  selectedOption: TestPurposeOption;
  primaryOptions: TestPurposeOption[] = [];
  continueAllowed = false;
  testTypeCssClass: string;
  otherUnsupportedForOnline = false;
  notListedPurposeId = 9;
  brandId: BrandEnum;
  otherChoiceIsAvailable: boolean;

  constructor(
    private configHelper: ConfigHelper
  ) { }

  ngOnInit(): void {
  }

  public get TestTypeEnum() {
    return TestTypeEnum;
  }

  //called when a new test purpose is selected
  ngOnChanges() {
    this.testTypeCssClass = this.configHelper.getTestTypeCssClass(this.testSession?.testTypeId);
    this.brandId = this.configHelper.getBrandId();
    this.buildTestPurposes();
    this.setOption(this.storedTestPurposeOption);
  }

  buildTestPurposes() {
    if (this.testPurposes) {
      this.primaryOptions = this.mapTestPurposeToOption(null, null);
      this.primaryOptions.forEach(x => {
        if (x.testPurposeId === TestPurposeEnum.IRCCParent) {
          x.children = this.mapTestPurposeToOption(x.testPurposeId, x.id);
        }
      });
    }
  }

  refreshTestPurposes() {
    if (this.testPurposes) {
      this.buildTestPurposes();
    }
  }

  mapTestPurposeToOption(parentId: number, parentIdStr: string): TestPurposeOption[] {
    const purposes = this.testPurposes
      .filter(x => x.isActive && x.parentId === parentId)
      .map(x => ({
        id: `${parentId}_${x.id}`,
        testPurposeId: x.id,
        parentId: parentIdStr,
        name: x.description,
        children: [],
        supportOnlineTest: x.supportOnlineTest
      }));
    const FilteredTestPurposes = this.isWebDelivery ? purposes.filter(s => s.supportOnlineTest === true) : purposes;
    return FilteredTestPurposes;
  }

  setOption(option: TestPurposeOption) {
    if (option) {
      this.selectedOption = option;
      this.otherUnsupportedForOnline = false;
      this.continueAllowed = option.children.length === 0 && option.testPurposeId !== this.notListedPurposeId;
    }
    this.selectNewTestPurpose.emit(this.storedTestPurposeOption);
  }

  public get TestPurposeEnum() {
    return TestPurposeEnum;
  }

  public get BrandEnum() {
    return BrandEnum;
  }

  clickContinue() {
    this.continue.emit(this.selectedOption);
  }

}
